import { useLocation } from 'react-router';
import cx from 'classnames';
import { css } from '@emotion/react';
import { PoweredByBirdi } from '@birdi/branding/powered-by-birdi';
import {
  SideBar,
  SidebarLink,
  dividerStyle,
  poweredByBirdiStyle,
  SideMenuHeader,
} from './side-bar-utils';
import { useMetaSelector } from '../../meta/reducer';
import GeneralSVG from '@birdi/icons/menu-general.svg';
import CustomizationSVG from '@birdi/icons/menu-customization.svg';
import UsersSVG from '@birdi/icons/menu-users.svg';
import ProcessingSVG from '@birdi/icons/menu-processing.svg';
import PermissionsSVG from '@birdi/icons/menu-permissions.svg';
import TagsSVG from '@birdi/icons/menu-tags.svg';
import { FeatureFlagNames } from '@birdi/js-sdk/src/public/organisation-features';
import { UpgradeIndicator } from '@birdi/components-common';

const SideNavigationWorkspace = () => {
  const location = useLocation();
  const meta = useMetaSelector();

  const { pathname } = location;
  const orgId = pathname.substring(pathname.lastIndexOf('/') + 1);

  const customBranding = meta.features.includes('brand-workspaces');

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <SideBar>
        <SideMenuHeader
          label="Workspace Settings"
          id="workspace-settings"
          backToPage="/admin-workspaces"
        />
        <SidebarLink to={`/workspace-general/${orgId}`} match={pathname}>
          <GeneralSVG />
          <span>General</span>
        </SidebarLink>
        <SidebarLink
          to={`/workspace-customization/${orgId}`}
          match={pathname}
          disabled={!customBranding}
        >
          <CustomizationSVG />
          <span
            css={css`
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 0.5em;
            `}
          >
            <span>Customization</span>
            {!customBranding && (
              <UpgradeIndicator message="Upgrade to customize your workspace" />
            )}
          </span>
        </SidebarLink>
        <SidebarLink to={`/workspace-users/${orgId}`} match={pathname}>
          <UsersSVG />
          <span>Users</span>
        </SidebarLink>
        <SidebarLink to={`/workspace-processing/${orgId}`} match={pathname}>
          <ProcessingSVG />
          <span>Processing</span>
        </SidebarLink>
        {/* <SidebarLink to={`/workspace-permissions/${orgId}`} match={history.location.pathname}>
          <PermissionsSVG />
          <span>Permissions</span>
        </SidebarLink>
        <SidebarLink to={`/workspace-data-tags/${orgId}`} match={history.location.pathname}>
          <TagsSVG />
          <span>Data Tags</span>
        </SidebarLink> */}
      </SideBar>
      <div css={poweredByBirdiStyle}>
        <PoweredByBirdi mode="dark" />
      </div>
    </div>
  );
};

export default SideNavigationWorkspace;
